import { connect } from 'react-redux'
import { RootState, store } from 'duck/store'
import { deleteOrganizationContent } from 'scenes/Dashboard/data/organizations/actions'

import OrganizationDeleteWarning, { OrganizationDeleteWarningProps } from './OrganizationDeleteWarning.presentational'
import { getOrganizationManagerPopupState } from '../../duck/selectors'
import { closeDeletePopup } from '../../duck/actions'

function mapStateToProps(state: RootState): StateProps {
  const { open, organizationId } = getOrganizationManagerPopupState(state)
  return {
    open,
    onClose: () => store.dispatch(closeDeletePopup()),
    onDelete: () => {
      store.dispatch(closeDeletePopup())
      if (organizationId) {
        store.dispatch(
          deleteOrganizationContent.request({
            organizationId,
          })
        )
      }
    },
  }
}

type StateProps = Pick<OrganizationDeleteWarningProps, 'open' | 'onClose' | 'onDelete'>

export default connect(mapStateToProps)(OrganizationDeleteWarning)
